import './PrintableOrder.css';

function PrintableOrder({ order }) {
  if (!order) return null;
  
  console.log('Order object:', order); // This will show us all available properties

  return (
    <div className="printable-order">
      {order.customerName && (
        <div className="customer-name">
          <h2>{order.customerName}</h2>
        </div>
      )}
      <div className="print-header">
        <div>
          <h1>PICK ORDER</h1>
          {order.CustomerRef && <p className="customer-ref"><strong>Customer Reference:</strong> {order.CustomerRef}</p>}
        </div>
        <div className="order-info">
          <p><strong>Order #:</strong> {order.idTrans}</p>
          <p><strong>Date:</strong> {new Date(order.transDate).toLocaleDateString()}</p>
        </div>
      </div>

      {(order.delName || order.delAddress || order.delCity || order.delState || order.delZip || order.delPhone) && (
        <div className="shipping-info">
          <div className="ship-to">
            <h3>SHIP TO</h3>
            {order.delName && <p><strong>{order.delName}</strong></p>}
            {order.delAddress && <p>{order.delAddress}</p>}
            {(order.delCity || order.delState || order.delZip) && (
              <p>
                {[order.delCity, order.delState, order.delZip].filter(Boolean).join(', ')}
              </p>
            )}
            {order.delPhone && <p>📞 {order.delPhone}</p>}
          </div>
        </div>
      )}

      <div className="order-items">
        <h3>ORDER ITEMS</h3>
        <table>
          <thead>
            <tr>
              <th style={{width: '12%'}}>Lot ID</th>
              <th style={{width: '15%'}}>Item #</th>
              <th style={{width: '25%'}}>Description</th>
              <th style={{width: '20%'}}>Notes</th>
              <th style={{width: '8%'}}>PPU</th>
              <th style={{width: '10%'}}>Qty</th>
              <th style={{width: '10%'}}>Total Pieces</th>
            </tr>
          </thead>
          <tbody>
            {order.items?.map((item) => (
              <tr key={item.idTrans2}>
                <td>{item.recTrans || ''}</td>
                <td>{item.itemNumber || ''}</td>
                <td>{item.itemName || ''}</td>
                <td>{item.notes || ''}</td>
                <td>{Number(item.ppu || 1).toLocaleString()}</td>
                <td>{Number(item.transQty || 0).toLocaleString()}</td>
                <td>{Number((item.transQty || 0) * (item.ppu || 1)).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="5" style={{ textAlign: 'right', fontWeight: 'bold' }}>Totals:</td>
              <td style={{ fontWeight: 'bold' }}>
                {order.items?.reduce((sum, item) => sum + (Number(item.transQty) || 0), 0).toLocaleString()}
              </td>
              <td style={{ fontWeight: 'bold' }}>
                {order.items?.reduce((sum, item) => sum + ((Number(item.transQty) || 0) * (Number(item.ppu) || 1)), 0).toLocaleString()}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="print-footer">
        <p>Printed: {new Date().toLocaleString()} | Order #{order.idTrans}</p>
      </div>
    </div>
  );
}

export default PrintableOrder; 